import { Controller } from "@hotwired/stimulus"

// Selección en masa V2 (checkboxes de una tabla), al modo ActiveAdmin: un
// checkbox de "todos" en el header y el botón de la acción masiva recién
// aparece con MÁS DE UNA fila marcada — para eliminar una está el eliminar por
// fila. El conteo viaja en el botón, que vive en el header de la card de
// vinculados.
//
// El estado visible vive en atributos del HTML (`hidden` del botón, `checked`
// de los checkboxes), nunca en clases puestas por JS (regla de morphing de
// Turbo). El controller vive en el <form> que envuelve las tablas del tab;
// los checkboxes los busca por nombre (`ids[]`): son una fila más de la tabla.
export default class extends Controller {
  static targets = ["submit", "count", "all"]

  // Un change en el form alcanza: solo los checkboxes del bulk disparan
  // cambios, y recontar es barato.
  toggle() {
    if (!this.hasSubmitTarget) return

    const selected = this.checkboxes.filter((checkbox) => checkbox.checked).length
    this.submitTarget.hidden = selected < 2
    if (this.hasCountTarget) this.countTarget.textContent = selected
    // todos los "todos" (libres y vinculados) quedan marcados solo si TODAS
    // las filas del form lo están
    this.allTargets.forEach((all) => { all.checked = selected > 0 && selected === this.checkboxes.length })
  }

  toggleAll(event) {
    this.checkboxes.forEach((checkbox) => { checkbox.checked = event.target.checked })
    this.toggle()
  }

  get checkboxes() {
    return Array.from(this.element.querySelectorAll('input[type="checkbox"][name="ids[]"]'))
  }
}
